import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: left;
  font-size: 1.2rem;
  color: var(--errorColor);
`
